import {
  Component,
  Input,
  HostBinding,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

const DEFAULT_SIZE = 24;

@Component({
  selector: 'sb-icon',
  templateUrl: './sb-icon.component.html',
  styleUrls: ['./sb-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbIconComponent {
  @Input()
  public name: string;

  @Input()
  public set size(size: number) {
    if (size && size !== DEFAULT_SIZE) {
      this.width = size;
      this.height = size;
    } else {
      this.width = DEFAULT_SIZE;
      this.height = DEFAULT_SIZE;
    }
  }

  /**
   * @description Color of icon
   */
  @HostBinding('style.color')
  @Input()
  public color: string;

  @HostBinding('style.width.px')
  public width: number = DEFAULT_SIZE;

  @HostBinding('style.height.px')
  public height: number = DEFAULT_SIZE;

  constructor(
    public el: ElementRef,
  ) { }

  public get absUrl(): string {
    return window.location.href;
  }
}
